import React from 'react';
import * as cls from './how-it-works.module.css';
import { ROUTES_PATHS } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';
import { Link } from 'react-router-dom';
import { Button } from '../../../../ui/components/button';

export const HowItWorks = () => {
  return (
    <Section classNameRoot={cls.section}>
      <Typography tag="h3">How it Works Under the Hood</Typography>
      <Typography>
        Voltaware converts home electricity signals into structured outputs:
        appliance-level usage, events, and higher-level indicators. These
        outputs are delivered through APIs (and optional event delivery) so your
        teams can build features, automate journeys, and measure impact, without
        maintaining complex ML pipelines in-house.
      </Typography>
      <Link className={cls.link} to={ROUTES_PATHS.INTEGRATE_WITH_VOLTAWARE}>
        <Button className={cls.button} variant="white-transparent">
          See full integration documentation
        </Button>
      </Link>
    </Section>
  );
};
